import React, { useRef } from 'react';
import VCHeroSection from '../../../components/landingPage/VCPage/VCHeroSection';
import SandboxSection from '../../../components/landingPage/common/SandboxSection';
import EcosystemSection from '../../../components/landingPage/common/EcosystemSection';
import VCStagesSection from '../../../components/landingPage/VCPage/VCStagesSection';
import VCStatsBand from '../../../components/landingPage/VCPage/VCStatsBand';
import VCQuotesSection from '../../../components/landingPage/VCPage/VCQuotesSection';
import VCPricingSection from '../../../components/landingPage/VCPage/VCPricingSection';
import VCCtaSection from '../../../components/landingPage/VCPage/VCCtaSection';
import { useReveal, useCountUp } from '../../../components/landingPage/common/landingHooks';
import AeoResourcesSection from '../../../components/landingPage/AeoArticles/AeoResourcesSection';
import useDocumentHead from '../../../components/landingPage/AeoArticles/useDocumentHead';
import hubWebPageSchema from '../../../components/landingPage/AeoArticles/aeoHubSchema';
import { AEO_HUBS } from '../../../components/landingPage/AeoArticles/aeoArticlesData';

const LandingHomeVCs = () => {
    const rootRef = useRef(null);
    useReveal(rootRef);
    useCountUp(rootRef);
    useDocumentHead({ canonicalPath: `${AEO_HUBS['vc']['hubPath']}/`, schema: hubWebPageSchema('vc') });

    return (
        <div className="lp-page" ref={rootRef}>
            <VCHeroSection />
            <SandboxSection />
            <EcosystemSection />
            <VCStagesSection />
            <VCStatsBand />
            <VCQuotesSection />
            <VCPricingSection />
            <VCCtaSection />
            <AeoResourcesSection icpSlug="vc" />
        </div>
    );
};

export default LandingHomeVCs;
